const errors = {
  COMMON_ERROR: "COMMON_ERROR",
  SHIPPING_ZIP_NOT_VALID_ERROR: "SHIPPING_ZIP_NOT_VALID_ERROR",
};

export default errors;
